// extracted by mini-css-extract-plugin
export default {"root":"_2NMP_","galleryWrapper":"dOyra","changing_background":"BCS2m","changingBackground":"BCS2m"};